import { render, staticRenderFns } from "./code-release.vue?vue&type=template&id=14fec28a&scoped=true&"
import script from "./code-release.vue?vue&type=script&lang=js&"
export * from "./code-release.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fec28a",
  null
  
)

export default component.exports